import { getHttpClient, NftApi } from '@capsicum/common';

export const nftApi = getHttpClient.then(client => new NftApi(client));

export * from './externalAdresses';
export * from './myCollectible';
export * from './myCollectibles';
export * from './transfer';
